import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { DataEntityEditorBaseComponent } from '../../data-entity-editor-base/data-entity-editor-base.component';
import { SignatureDataEntity } from 'src/app/models/data-entities/signature-data-entity';

@Component({
    selector: 'wm-signature-data-entity-editor',
    templateUrl: './signature-data-entity-editor.component.html',
    styleUrls: ['./signature-data-entity-editor.component.css'],
    standalone: false
})
export class SignatureDataEntityEditorComponent
  extends DataEntityEditorBaseComponent
  implements OnInit {
  signatureDataEntity: SignatureDataEntity;

  constructor(private _fb: UntypedFormBuilder) {
    super();
  }

  ngOnInit() {
    this.signatureDataEntity = this.dataEntity as SignatureDataEntity;

    this.form.addControl(
      'includePrintedName',
      this._fb.control(this.signatureDataEntity.includePrintedName, [Validators.nullValidator])
    );
  }
}
